export interface AiOutputPreviewDataItem {
	pii?: boolean | null;
	tags?: string[] | null;
	description?: string | null;
	definition?: string | null;
}

export type AiOutputPreviewData = Record<string, AiOutputPreviewDataItem>;

export const isValidPreviewData = (
	data: unknown
): data is AiOutputPreviewData => {
	if (!data || typeof data !== 'object' || Array.isArray(data)) {
		return false;
	}

	const obj = data as Record<string, unknown>;

	return Object.values(obj).every((item) => {
		if (!item || typeof item !== 'object' || Array.isArray(item)) {
			return false;
		}

		const itemObj = item as Record<string, unknown>;

		const hasValidPii =
			!('pii' in itemObj) ||
			typeof itemObj.pii === 'boolean' ||
			itemObj.pii === null;

		const hasValidTags =
			!('tags' in itemObj) ||
			itemObj.tags === null ||
			(Array.isArray(itemObj.tags) &&
				itemObj.tags.every((tag) => typeof tag === 'string'));

		const hasValidDescription =
			!('description' in itemObj) ||
			typeof itemObj.description === 'string' ||
			itemObj.description === null;

		const hasValidDefinition =
			!('definition' in itemObj) ||
			typeof itemObj.definition === 'string' ||
			itemObj.definition === null;

		return (
			hasValidPii && hasValidTags && hasValidDescription && hasValidDefinition
		);
	});
};
